import { forwardRef } from 'react';

import { getLineHeight, getRem, typographyBody1 } from 'lib/core';
import { ie11ReadOnlyStyles, INPUT_SIZES } from 'lib/input';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledTextAreaField = styled.textarea`
  ${({ theme }) => typographyBody1(theme)};
  background-color: transparent;
  border-width: 0;
  box-shadow: none;
  box-sizing: border-box;
  outline: none;
  overflow: auto;
  padding: 0 ${getRem('12px')} 0;
  resize: none;

  &::placeholder {
    color: ${({ theme }) => theme.color.gray[600].value};
    font-weight: ${({ theme }) => theme.font.weight.light.value};
  }

  &:disabled {
    cursor: not-allowed;
  }

  ${({ $size }) => css`
    ${$size === INPUT_SIZES.LARGE &&
    css`
      font-size: ${getRem('16px')};
      line-height: ${getLineHeight('24px', '16px')};
    `}
  `}
  ${({ $isReadOnly }) => $isReadOnly && ie11ReadOnlyStyles}
`;

const TextAreaField = forwardRef(({ hideLabel, isReadOnly, maxRows, size, ...other }, ref) => (
  <StyledTextAreaField
    $isReadOnly={isReadOnly}
    $size={size}
    $hideLabel={hideLabel}
    $maxRows={maxRows}
    {...other}
    ref={ref}
  />
));

export { TextAreaField };

TextAreaField.propTypes = {
  /** If true, hide the label */
  hideLabel: PropTypes.bool,
  /** If true, use read only styling */
  isReadOnly: PropTypes.bool,
  /** Maximum allowed rows before scrolling */
  maxRows: PropTypes.number,
  /** Input size */
  size: PropTypes.oneOf(Object.values(INPUT_SIZES)),
};
